<p>term-condition works!</p>
